export default __webpack_public_path__ + "static/media/domain-deactivated.1afe8d87.svg";